// src/views/incidencias/IncidenciaDetalle.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE } from "../../apiConfig";
import { FiArrowLeft, FiExternalLink, FiCopy, FiRefreshCw } from "react-icons/fi";

export default function IncidenciaDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [pdfUrl, setPdfUrl] = useState("");
  const [error, setError] = useState("");

  const cargarPdf = async () => {
    try {
      setLoading(true);
      setError("");

      // ✅ Tu API actual (según tu Postman): POST /incidencias/{id}/pdf
      const res = await axios.post(`${API_BASE}/incidencias/${id}/pdf`, {});
      const url = res.data?.url || "";
      if (!url) throw new Error("La API no devolvió url de PDF");

      setPdfUrl(url);
    } catch (e) {
      console.error(e);
      setError("No se pudo generar/obtener el PDF. Revisa API Gateway/Lambda/S3.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!id) return;
    cargarPdf();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const copiarLink = async () => {
    if (!pdfUrl) return;
    try {
      await navigator.clipboard.writeText(pdfUrl);
      alert("Link copiado ✅");
    } catch {
      alert("No se pudo copiar (permiso del navegador).");
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-5">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">
            Incidencia {id}
          </h1>
          <p className="text-sm text-slate-500">
            Aquí puedes abrir, copiar y compartir el PDF generado.
          </p>
        </div>

        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 rounded-xl border border-slate-200 bg-white hover:bg-slate-50 flex items-center gap-2"
          >
            <FiArrowLeft /> Volver
          </button>

          <button
            onClick={cargarPdf}
            className="px-4 py-2 rounded-xl border border-slate-200 bg-white hover:bg-slate-50 flex items-center gap-2"
          >
            <FiRefreshCw /> Regenerar link
          </button>

          <Link
            to="/incidencias"
            className="px-4 py-2 rounded-xl bg-slate-900 text-white hover:bg-slate-800"
          >
            Ir al listado
          </Link>
        </div>
      </div>

      {/* Estado */}
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5">
        {loading ? (
          <div className="text-slate-700">Generando PDF…</div>
        ) : error ? (
          <div className="text-red-600 font-semibold">{error}</div>
        ) : (
          <>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
              <div className="text-sm text-slate-600">
                PDF listo. El link es temporal (presigned). Puedes abrirlo o copiarlo.
              </div>

              <div className="flex flex-wrap gap-2">
                <a
                  href={pdfUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="px-4 py-2 rounded-xl bg-indigo-600 text-white hover:bg-indigo-700 flex items-center gap-2"
                >
                  <FiExternalLink /> Abrir PDF
                </a>

                <button
                  onClick={copiarLink}
                  className="px-4 py-2 rounded-xl border border-slate-200 bg-white hover:bg-slate-50 flex items-center gap-2"
                >
                  <FiCopy /> Copiar link
                </button>
              </div>
            </div>

            {/* Preview */}
            <div className="rounded-2xl overflow-hidden border border-slate-200 bg-slate-50">
              <iframe
                title="PDF Preview"
                src={pdfUrl}
                className="w-full h-[70vh]"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
